import { home } from './home'

export const module = [...home]